import React from 'react'

type RadioButtonProps = {
  name: string;
  active: boolean;
  onClick: React.MouseEventHandler<HTMLButtonElement>;
}

export const RadioButton: React.FC<RadioButtonProps> = ({ name, active, onClick }) => (
  <button type="button" className={`btn btn-secondary ${active ? 'active' : ''}`} onClick={onClick}>{name}</button>
)

type RadioButtonGroupProps<T> = {
  className: string;
  collection: {
    name: string;
    value: T;
  }[];
  currentValue?: T;
  onChange: (value: T) => void;
}

export function RadioButtonGroup<T extends string>({ className, collection, currentValue, onChange }: RadioButtonGroupProps<T>) {
  return <div className={`btn-group ${className}`}>
    {collection.map(
      b => <RadioButton
        key={b.value}
        name={b.name}
        active={b.value === currentValue}
        onClick={() => onChange(b.value)}
      />
    )}
  </div>
}
